/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=81278912"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wuxieshuan/Desktop/上海印高/WeCom_FE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/header-fullscreen/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81278912"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81278912', __exports__)) {
    console.log('reload')
    api.reload('81278912', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=81278912", () => {
    console.log('re-render')
    api.rerender('81278912', render)
  })

}


export default __exports__